import React, { useState, useEffect } from 'react';
import { isAuthenticated } from '../../store/action/auth';
import { uploadAdminOrderFile, createAdminBulkOrders } from '../../store/action/order';
import AdminFileOrderTable from "../../components/tables/AdminFileOrderTable";
import {Button} from "../../components/buttons";

const BulkOrder = (props) => {
    const { token } = isAuthenticated();
    const [ loading, setLoading ] = useState(false);
    const [ submitLoading, setSubmitLoading ] = useState(false);
    const [ orders, setOrders ] = useState([]);

    const onSelectOrderFile = async (e) => {
        setLoading(true);
        try {
            const data = e.target.files[0];
            const res = await uploadAdminOrderFile(token, data);
            if (res.success) {
                setOrders(res.file)
            } else {
                alert("Gagal upload file")
            }
        } catch (e) {
            console.log (e);
            alert(`${e.message}`)
        }
        setLoading(false);
    };

    const onSubmitOrders = async () => {
        setSubmitLoading(true);
        try {
            const { userId } = orders[0];
            const res = await createAdminBulkOrders(token, userId, orders);
            if (res.success) {
                alert(`Berhasil memasukan ${res.total_orders} data`);
                window.location.reload()
            } else {
                alert(`${res.error}`)
            }
        } catch (e) {
            console.log (e);
            alert(e.message)
        }
        setSubmitLoading(false);
    };

    if (loading) {
        return (
            <div className="bg-white rounded shadow p-4">
                <p>Uploading file...</p>
            </div>
        )
    }

    if (orders.length > 0) {
        return (
            <div>
                <div className="p-4 d-flex justify-content-between">
                    <h5 className="text-center">Data Pesanan</h5>
                    <Button
                        onClick={onSubmitOrders}
                        loading={submitLoading}
                        className="btn btn-primary btn-sm my-2 my-sm-0"
                    >
                        {loading ? "Mengirim data..." : "Kirim data order"}
                    </Button>
                </div>
                <div className="px-4">
                    <h5>User Id {orders[0].userId}</h5><br/>
                    <h5>Bulk Order Id {orders[0].bulkOrderId}</h5>
                </div>
                <AdminFileOrderTable
                    data={orders}
                />
            </div>
        )
    }
    return (
        <div className="bg-white rounded shadow p-4">
            <h2 className="text-center">Upload File Pesanan</h2>
            <div className="my-4"/>
            <div className="row">
                <div className="custom-file mt-2 text-center">
                  <input
                      type="file"
                      className="btn-secondary upload-product-image"
                      id="file"
                      accept="application/*"
                     onChange={e => onSelectOrderFile(e)}
                  />
                  <label htmlFor="file" className="btn-1">Upload File Pesanan</label>
                </div>
            </div>
        </div>
    )
};

export default BulkOrder;
